(function(){
  var raiz = document.querySelector('.lcd');
  if(!raiz) return;
  var form = raiz.querySelector('#comprar');
  var btn = raiz.querySelector('#lcd-btn');
  var idInput = raiz.querySelector('#lcd-id');
  var qty = raiz.querySelector('#lcd-qty');
  var total = raiz.querySelector('#lcd-total');
  var aho = raiz.querySelector('#lcd-ahorro');
  var fp = raiz.querySelector('#lcd-fija-precio');
  var packs = raiz.querySelectorAll('.lcd-pack');
  var urlAdd = raiz.getAttribute('data-cart-add') || '/cart/add';
  var urlClear = raiz.getAttribute('data-cart-clear') || '/cart/clear';
  var formularioAbierto = false;
  var hayOfertas = false;
  var CLAVE = 'lcd-pack';

  /* Paquete guardado antes de una recarga, o indicado en la direccion */
  var pk = null;
  try { pk = new URLSearchParams(window.location.search).get('pack'); } catch(e){}
  try { var g = window.sessionStorage.getItem(CLAVE); if(g){ pk = g; window.sessionStorage.removeItem(CLAVE); } } catch(e){}
  if(pk){ packs.forEach(function(p){ var i = p.querySelector('input'); if(i && !i.disabled && i.value === pk) i.checked = true; }); }

  function pinta(avisa){
    packs.forEach(function(p){
      var i = p.querySelector('input');
      if(!i) return;
      p.classList.toggle('sel', i.checked);
      if(!i.checked) return;
      if(total) total.textContent = i.dataset.precio;
      if(fp) fp.textContent = i.dataset.titulo + ', ' + i.dataset.precio;
      if(aho) aho.textContent = i.dataset.ahorro ? 'Ahorras ' + i.dataset.ahorro + ' frente a comprarlos por separado' : '';
      if(qty && qty.value !== i.value){
        qty.value = i.value;
        if(avisa){
          qty.dispatchEvent(new Event('input', { bubbles: true }));
          qty.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  /* Releasit con ofertas por cantidad: su formulario abre con la oferta que tenga preseleccionada.
     Al abrirlo se marca la oferta que coincide con el paquete elegido en la pagina.
     Se espera a que el formulario termine de montarse y se comprueba varias veces,
     porque un clic demasiado temprano deja cantidad y descuento descuadrados. */
  function sincronizaOferta(){
    var n = qty ? Number(qty.value) || 1 : 1;
    var vueltas = 0;
    var intentos = 0;
    function radio(){
      var d = document.querySelector('#rsi_form_wrapper');
      return d && d.querySelector('input[name="quantity_offer"][value="quantity_' + (n - 1) + '"]');
    }
    function ajusta(){
      var r = radio();
      if(!r || r.checked || intentos >= 5) return;
      intentos++;
      (r.closest('label') || r).click();
    }
    var reloj = setInterval(function(){
      vueltas++;
      if(radio()){
        hayOfertas = true;
        clearInterval(reloj);
        setTimeout(ajusta, 600);
        setTimeout(ajusta, 1500);
        setTimeout(ajusta, 2600);
        setTimeout(ajusta, 4000);
        setTimeout(ajusta, 6000);
      } else if(vueltas > 60){
        clearInterval(reloj);
      }
    }, 150);
  }

  document.addEventListener('click', function(e){
    if(e.target && e.target.closest && e.target.closest('#rsi_buy_now_button')){
      formularioAbierto = true;
      sincronizaOferta();
    }
  }, true);

  /* Sin ofertas, Releasit fija la cantidad la primera vez que abre: se recarga con el paquete nuevo. */
  packs.forEach(function(p){
    var i = p.querySelector('input');
    if(!i) return;
    i.addEventListener('change', function(){
      pinta(true);
      if(formularioAbierto && !hayOfertas){
        try { window.sessionStorage.setItem(CLAVE, i.value); } catch(e){}
        window.location.reload();
      }
    });
  });
  pinta(false);
  if(pk && form && form.scrollIntoView){ try { form.scrollIntoView({ block: 'center' }); } catch(e){} }

  if(form && btn){
    form.addEventListener('submit', function(e){
      if(form.querySelector('#rsi_buy_now_button')){ e.preventDefault(); return; }
      if(!idInput || !idInput.value || !window.fetch) return;
      e.preventDefault();
      btn.disabled = true;
      var n = qty ? Number(qty.value) || 1 : 1;
      fetch(urlClear + '.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function(){
          return fetch(urlAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: n }] }) });
        })
        .then(function(r){ if(!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
        .catch(function(){ btn.disabled = false; form.submit(); });
    });
  }

  var pista = raiz.querySelector('#lcd-pista');
  var minis = raiz.querySelectorAll('.lcd-mini');
  function marca(k){ minis.forEach(function(m, j){ m.classList.toggle('act', j === k); }); }
  if(pista && minis.length){
    marca(0);
    minis.forEach(function(m, k){ m.addEventListener('click', function(){ pista.scrollTo({ left: k * pista.clientWidth, behavior: 'smooth' }); marca(k); }); });
    pista.addEventListener('scroll', function(){ marca(Math.round(pista.scrollLeft / pista.clientWidth)); }, { passive: true });
  }

  var fija = raiz.querySelector('#lcd-fija');
  if(fija && form && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){ fija.classList.toggle('ver', !en[0].isIntersecting); }).observe(form);
  }
})();
